export default __webpack_public_path__ + "static/media/alcance.a22a43d7.svg";